import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["handleDeleteOneTask"];
/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { alertBulkActionFailure, genericAlertWarning } from '../../../alerts/bulkActionsAlerts';
import { DEFAULT_BULK_ACTIONS_DELETE_TASKS_MODAL_KEY } from '../../../constants/modalKeys';
import { useBulkActionsHasError } from '../../../hooks/useBulkActionsHasError';
import { useBulkActionsIsLoading } from '../../../hooks/useBulkActionsIsLoading';
import { useBulkActionsNumberOfSelectedObjects } from '../../../hooks/useBulkActionsNumberOfSelectedObjects';
import { useBulkActionsOpenModal } from '../../../hooks/useBulkActionsOpenModal';
import { useBulkActionsPermissionsForCurrentSelection } from '../../../hooks/useBulkActionsPermissionsForCurrentSelection';
import { useBulkActionsSelectionState } from '../../../hooks/useBulkActionsSelectionState';
import { bulkFetchTasksAndSequenceCheck } from '../../../utils/TasksUtils';
import { BaseBulkActionButton } from '../BaseBulkActionButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultBulkActionsDeleteTasksOnSuccess = ({
  allSelected,
  count
}) => {
  if (allSelected) {
    genericAlertWarning({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "bulkActions.alerts.tasks.delete.submitted"
      })
    });
  } else {
    genericAlertWarning({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "bulkActions.alerts.tasks.delete.success",
        options: {
          count
        }
      })
    });
  }
};
export const DefaultBulkActionsDeleteTasksOnFailure = ({
  count
}) => {
  alertBulkActionFailure({
    count,
    langkey: 'bulkActions.alerts.tasks.delete.failure'
  });
};
export const DeleteTasks = ({
  buttonProps
}) => {
  const {
      handleDeleteOneTask
    } = buttonProps,
    rest = _objectWithoutPropertiesLoose(buttonProps, _excluded);
  const openModal = useBulkActionsOpenModal();
  const {
    selectionIds = []
  } = useBulkActionsSelectionState();
  const count = useBulkActionsNumberOfSelectedObjects();
  const isLoading = useBulkActionsIsLoading();
  const hasError = useBulkActionsHasError();
  const canBulkEditTasks = useBulkActionsPermissionsForCurrentSelection('canEdit');
  const disabled = isLoading || hasError || !canBulkEditTasks;
  const onClick = useCallback(() => {
    // when only one task is completed, give the option to use a different behavior
    // and give the option to update repeating task behavior using the tasks endpoint
    if (handleDeleteOneTask && count === 1) {
      return handleDeleteOneTask();
    }
    const {
      logFunction,
      onFailure = DefaultBulkActionsDeleteTasksOnFailure
    } = rest;
    return bulkFetchTasksAndSequenceCheck(selectionIds, count, {
      logFunction,
      onFailure
    }).then(taskDependencyStep => {
      const taskInSequence = Boolean(taskDependencyStep);
      openModal({
        modalKey: DEFAULT_BULK_ACTIONS_DELETE_TASKS_MODAL_KEY,
        props: Object.assign({}, rest, {
          shouldUseSequenceMessage: taskInSequence
        })
      });
    });
  }, [count, handleDeleteOneTask, openModal, rest, selectionIds]);
  return /*#__PURE__*/_jsx(BaseBulkActionButton, {
    "data-test-id": "bulk-actions-delete-tasks",
    disabled: disabled,
    disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "bulkActions.buttonDisabledTooltips.tasks.generic"
    }),
    icon: "delete",
    isLoading: isLoading,
    onClick: onClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "bulkActions.buttonLabels.tasks.deleteTasks"
    })
  });
};